const path = require('path')
const winston = require('winston')
const fs = require('fs')

const format = winston.format.combine(
  winston.format.timestamp(),
  winston.format.printf((info) => `${info.timestamp} ${info.level}: ${info.message}`),
)

const { NODE_ENV, EXPERIMENTAL } = process.env

const transports = []
if (NODE_ENV !== 'production') {
  transports.push(new winston.transports.Console({ format }))
}

const appName = EXPERIMENTAL === 'true' ? 'marketing-site-experimental' : 'marketing-site-static'
const logsDirPath = NODE_ENV === 'production' ? `/apps/${appName}/shared/log` : 'log'

if (fs.existsSync(logsDirPath)) {
  const logName = `${NODE_ENV || 'development'}.log`
  const filename = path.join(logsDirPath, logName)
  transports.push(new winston.transports.File({ filename, format }))
}

const logger = winston.createLogger({ transports, level: 'info' })

module.exports = logger
